<template>
    <div class="paragraph-settings">
        <div class="setting-section">
            <div class="setting-label">Üst Boşluk</div>
            <div class="spacing-input">
                <input 
                    type="number" 
                    v-model.number="localMarginTop"
                    @input="updateMarginTop(localMarginTop)"
                    @focus="focusedField = 'marginTop'"
                    @blur="focusedField = null"
                    min="0"
                    max="100"
                    class="spacing-field"
                    placeholder="0"
                />
                <span class="unit">px</span>
            </div>
        </div>

        <div class="setting-section">
            <div class="setting-label">Alt Boşluk</div>
            <div class="spacing-input">
                <input 
                    type="number" 
                    v-model.number="localMarginBottom"
                    @input="updateMarginBottom(localMarginBottom)"
                    @focus="focusedField = 'marginBottom'"
                    @blur="focusedField = null"
                    min="0"
                    max="100"
                    class="spacing-field"
                    placeholder="0"
                />
                <span class="unit">px</span>
            </div>
        </div>

        <div class="setting-section">
            <div class="setting-label">Görünürlük</div>
            <div class="spacing-input">
                <input 
                    type="checkbox" 
                    id="paragraph-visibility"
                    v-model="localVisibility"
                    @change="updateField"
                    style="width: auto; margin-right: 8px;"
                />
                <label for="paragraph-visibility" style="cursor: pointer;">Alan görünür</label>
            </div>
        </div>

        <div class="setting-section">
            <div class="setting-label">URL Parametresi</div>
            <input
                type="text"
                v-model="localSlug"
                @input="setSlug($event.target.value)"
                class="spacing-field"
                placeholder="paragraph"
                style="width: 100%;"
                ref="slugInput"
            />
            <small style="font-size: 0.75rem; color: #6b7280; margin-top: 0.25rem; display: block;">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "ParagraphSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            localMarginTop: this.item.paragraph && this.item.paragraph.marginTop || 0,
            localMarginBottom: this.item.paragraph && this.item.paragraph.marginBottom || 0,
            localVisibility: this.item.visibility !== undefined ? this.item.visibility : true,
            localSlug: this.item.slug || '',
            updateTimer: null,
            focusedField: null,
        };
    },
    watch: {
        'item.paragraph.marginTop': function (v) {
            if (this.focusedField !== 'marginTop') {
                this.localMarginTop = v || 0;
            }
        },
        'item.paragraph.marginBottom': function (v) {
            if (this.focusedField !== 'marginBottom') {
                this.localMarginBottom = v || 0;
            }
        },
        item: {
            deep: true,
            handler: function (val) {
                if (!val || !val.paragraph) return;
                if (this.focusedField !== 'marginTop') {
                    this.localMarginTop = val.paragraph.marginTop || 0;
                }
                if (this.focusedField !== 'marginBottom') {
                    this.localMarginBottom = val.paragraph.marginBottom || 0;
                }
                if (this.focusedField !== 'slug') {
                    this.localVisibility = val.visibility !== undefined ? val.visibility : true;
                    this.localSlug = val.slug || '';
                }
            }
        }
    },
    methods: {
        ...mapActions({
            updateFormField: "forms/updateFormField",
        }),
        updateMarginTop(value) {
            this.localMarginTop = value;
            this.$emit('update-margin-top', value);
            this.updateField();
        },
        updateMarginBottom(value) {
            this.localMarginBottom = value;
            this.$emit('update-margin-bottom', value);
            this.updateField();
        },
        updateSpacing() {
            this.updateMarginTop(this.localMarginTop);
            this.updateMarginBottom(this.localMarginBottom);
        },
        setSlug(slug) {
            this.localSlug = this.sanitizeSlug(slug);
            this.updateField();
        },
        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateFields = {
                    label: self.item.label || "Paragraf",
                    visibility: self.localVisibility,
                    slug: self.localSlug,
                    paragraph: {
                        ...self.item.paragraph,
                        marginTop: self.localMarginTop || 0,
                        marginBottom: self.localMarginBottom || 0,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
                self.$emit("update-field", updateFields);
            }, 800);
        },
    }
};
</script>

<style lang="scss" scoped>
.paragraph-settings {
    padding: 1rem;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    border: 1px solid rgba(242, 106, 82, 0.1);
    box-shadow: 0 4px 20px rgba(242, 106, 82, 0.1);

    .setting-section {
        margin-bottom: 1.5rem;

        &:last-child {
            margin-bottom: 0;
        }

        .setting-label {
            font-size: 0.875rem;
            font-weight: 600;
            color: #374151;
            margin-bottom: 0.75rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;

            &::before {
                content: '';
                width: 3px;
                height: 16px;
                background: linear-gradient(135deg, #f26a52 0%, #e55a42 100%);
                border-radius: 2px;
            }
        }
    }

    .spacing-input {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        .spacing-field {
            flex: 1;
            padding: 0.75rem;
            border: 2px solid #e5e7eb;
            border-radius: 8px;
            font-size: 0.875rem;
            transition: all 0.3s ease;
            background: white;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
            }

            &::placeholder {
                color: #9ca3af;
            }
        }

        .unit {
            font-size: 0.75rem;
            font-weight: 500;
            color: #6b7280;
            padding: 0.25rem 0.5rem;
            background: #f3f4f6;
            border-radius: 4px;
        }
    }

    // Responsive
    @media (max-width: 768px) {
        padding: 0.75rem;

        .setting-section {
            margin-bottom: 1rem;
        }

        .spacing-input .spacing-field {
            padding: 0.625rem;
            font-size: 0.8125rem;
        }
    }
}
</style>
